import createReducer from 'redux/lib/reducerConfig';

const ActionTypes = {
  SET_CURRENCY_PLAN: 'MARKET_PRICE/CURRENCY_PLAN/SET_CURRENCY_PLAN',
};

export const filterInitialState = null;

export const setCurrencyPlan = (currencyPlan) => ({
  type: ActionTypes.SET_CURRENCY_PLAN,
  payload: currencyPlan,
});

export const currencyPlanReducer = createReducer(
  filterInitialState,
  {
    [ActionTypes.SET_CURRENCY_PLAN]: (state, { payload }) => {
      return payload;
    },
  },
);

